import { purchaseService } from '@/services';

export const purchaseModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    purchase:{
      data: null,
      error: null,
    },
    purchasesExcel:{
      data: null,
      error: null,
    },
    purchaseTracking:{
      data: null,
      error: null
    },
    purchaseResource:{
      data: {
        images: null,
        documents: null,
      },
      error: null
    },
    onHoldStatus:{
      data: null,
      status: null
    },
    cancelEntity:{
      data: null,
      status: null
    },
    recoverEntity:{
      data: null,
      status: null
    },
  }),
  mutations: {
    loadResource(state, purchaseId) {
      purchaseService.getResources(purchaseId)
        .then((res) => {
          state.purchaseResource.data = { ...res }
        })
        .catch((error) => {
          state.purchaseResource.data.images = null
          state.purchaseResource.data.documents = null
          state.purchaseResource.error = error
        });      
    },
    appendImage(state, entity) {
      state.purchaseResource.data.images.push(entity)
    },
    appendDocument(state, entity) {
      state.purchaseResource.data.documents.push(entity)
    },
    removeImage(state, entity) {
      const currentImages = [ ...state.purchaseResource.data.images ]
      state.purchaseResource.data.images = currentImages.filter(image => image['name'] != entity['name'])
    },
    removeDocument(state, entity) {
      const currentDocuments = [ ...state.purchaseResource.data.documents ]
      state.purchaseResource.data.documents = [ ...currentDocuments.filter(document => document['name'] != entity['name']) ]
    },
    downloadResource(state,request){
      purchaseService.downloadResource(request.purchaseId, request.fileName)
      .then((excel) => {
        state.purchaseResource.data = excel
        state.purchaseResource.error = null
      })
      .catch((error) => {
        state.purchaseResource.data = null
        state.purchaseResource.error = error
      });
    },
    resetResources(state) {
      state.purchaseResource.data.images = null
      state.purchaseResource.data.documents = null
      state.purchaseResource.error = null     
    },
    load(state,request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      purchaseService.getPurchase(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getById(state, id) {
      purchaseService.getPurchaseById(id)
        .then((res) => {
          state.purchase.data = res
        })
        .catch((error) => {
          state.purchase.data = null
          state.purchase.error = error
        });      
    },
    purchasesExcel(state,request){
      purchaseService.getPurchasesAsExcel(request.filters, request.language)
      .then((excel) => {
        state.purchasesExcel.data = excel
        state.purchasesExcel.error = null
      })
      .catch((error) => {
        state.purchasesExcel.data = null
        state.purchasesExcel.error = error
      });
    },
    getTracking(state, orderId) {
      purchaseService.getTracking(orderId)
        .then((res) => {
          state.purchaseTracking.data = res
        })
        .catch((error) => {
          state.purchaseTracking.data = null
          state.purchaseTracking.error = error
        });      
    },
    onHoldStatus(state, payload){
      purchaseService.onHoldStatus({ on_hold: payload.on_hold }, payload.entityId)
      .then((res) => {
        state.onHoldStatus.data = { ...res }
        state.onHoldStatus.status = {
          onHoldStatus: true
        }
      })
      .catch((error) => {
        state.onHoldStatus.data = null
        state.onHoldStatus.status = {
          ...error
        }
      }); 
    },
    cancel(state, entityId){
      purchaseService.cancel(entityId)
      .then((res) => {
        state.cancelEntity.data = { ...res }
        state.cancelEntity.status = {
          canceled: true,
        }
      })
      .catch((error) => {
        state.cancelEntity.data = null
        state.cancelEntity.status = {
          ...error
        }
      }); 
    },
    recover(state, entityId){
      purchaseService.recover(entityId)
      .then((res) => {
        state.recoverEntity.data = { ...res }
        state.recoverEntity.status = {
          recovered: true,
        }
      })
      .catch((error) => {
        state.recoverEntity.data = null
        state.recoverEntity.status = {
          ...error
        }
      }); 
    },
  }
}